export class CfgMtrlSource {
}
export class CfgMtrlSourceUrl extends CfgMtrlSource {
    constructor(_url, _urlIsFromProperty) {
        super();
        this._url = _url;
        this._urlIsFromProperty = _urlIsFromProperty;
    }
    get url() {
        return this._url;
    }
    get urlIsFromProperty() {
        return this._urlIsFromProperty;
    }
    isSame(other) {
        if (!(other instanceof CfgMtrlSourceUrl)) {
            return false;
        }
        return this.url === other.url;
    }
}
export class CfgMtrlSourceBuffer extends CfgMtrlSource {
    constructor(_fileName, _buffer) {
        super();
        this._fileName = _fileName;
        this._buffer = _buffer;
    }
    get fileName() {
        return this._fileName;
    }
    get buffer() {
        return this._buffer;
    }
    isSame(other) {
        if (!(other instanceof CfgMtrlSourceBuffer)) {
            return false;
        }
        return this.fileName === other.fileName;
    }
}
